import defaultState from "./state";

const cotizacionesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "OPEN_CLOSE_NOTIF_COTIZACIONES": {
      return Object.assign({}, state, {
        isOpenModalNotifCotizaciones: action.isOpen,
      });
    }
    case "SET_SHOWHIDE_FORM_COTIZACIONES": {
      const actualState = { ...state };
      return Object.assign({}, state, {
        showHideFormCotizaciones: action.showHideFormCotizaciones,
      });
    }
    case "SET_SHOWHIDE_SENDING_TEXT": {
      return Object.assign({}, state, {
        showSendingText: action.showSendingText,
      });
    }
    default:
      return state;
  }
};

export default cotizacionesReducer;
